import { useEffect, useState } from "react";

const FetchSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    fetch("https://jdmember.tjdstore.in/backend/fetch_subscriptions.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Subscriptions:", data);

        // Remove duplicates using Map (based on id)
        const uniqueSubscriptions = Array.from(new Map(data.map(sub => [sub.id, sub])).values());

        // Filter: Only active subscriptions + Ensure 'start_at' exists and is valid
        const filteredSubscriptions = uniqueSubscriptions.filter(sub => 
          sub.status === "active" && sub.start_at
        );

        setSubscriptions(filteredSubscriptions);
      })
      .catch((error) => console.error("Error fetching subscriptions:", error));
  }, []);

  // Function to convert Unix timestamp to readable date format
  const formatDate = (timestamp) => {
    if (!timestamp) return null; // Skip if timestamp is missing
    const date = new Date(timestamp * 1000);
    return date.toLocaleString("en-IN", { 
      day: "2-digit", 
      month: "2-digit", 
      year: "numeric", 
      hour: "2-digit", 
      minute: "2-digit", 
      second: "2-digit" 
    });
  };

  // Function to check if the end date is within 60 days from today
  const isExpiringSoon = (timestamp) => {
    if (!timestamp) return false;
    const endDate = new Date(timestamp * 1000);
    const today = new Date();
    const diffInDays = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
    return diffInDays <= 60; // Return true if end_at is within 60 days
  };

  // Function to map plan_id to a name
  const getPlanName = (plan_id) => {
    const planMappings = {
      "plan_GvIcpS5vs5u6wD": "Standard Plan",
      "plan_GvIcVc0piwj8sR": "Premium Plan",
      "plan_GvIak1nGJFR2TV": "Basic Plan",
      "plan_GvIgvBkjRpIElO": "Sehdev",
      "plan_GvIhJqejdLXX5O": "Nakul",
      "plan_GvIhh5gt3kJBLV": "Yudhistar",
      "plan_GvIi7uuK5XUSN5": "Bheem",
      "plan_GvIiPacNMHHbTi": "Arjun",
      "plan_GvIp8DalpPc9DS": "Karma",
      "plan_GvIpYDxccgjwAd": "Dharma"
    };
    return planMappings[plan_id] || "Other Plan"; // Default if plan_id is unknown
  };

  // Function to determine price based on plan name
  const getPrice = (planName) => {
    if (planName === "Standard Plan") return 500;
    if (planName === "Premium Plan") return 250;
    if (planName === "Basic Plan") return 100;
    if (planName === "Sehdev") return 1000;
    if (planName === "Nakul") return 2500;
    if (planName === "Yudhistar") return 5000;
    if (planName === "Bheem") return 7500;
    if (planName === "Arjun") return 10000;            
    if (planName === "Karma") return 25000;            
    if (planName === "Dharma") return 50000;                
    return 1000; // Default price
  };

  return (
    <div>
      <h2>Active Subscriptions</h2>
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Plan Name</th>
            <th>Price (₹)</th> {/* New Price Column */}
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Payment Method</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((sub, index) => {
            const planName = getPlanName(sub.plan_id);
            const price = getPrice(planName); // Get price based on plan
            const startDate = formatDate(sub.start_at);
            if (!startDate) return null; // Skip row if start date is missing

            const endDate = formatDate(sub.end_at);
            const expiringSoon = isExpiringSoon(sub.end_at); // Check if it's expiring soon

            return (
              <tr key={sub.id}>
                <td>{index + 1}</td>
                <td>{planName}</td>
                <td>{price}</td> {/* Display price */}
                <td>{sub.notes?.name || "N/A"}</td>
                <td>{sub.notes?.mobile_number || "N/A"}</td>
                <td>{sub.notes?.email_address || "N/A"}</td>
                <td>{startDate}</td>
                <td 
                  style={{ 
                    backgroundColor: expiringSoon ? "#b71c1c" : "#1b5e20", 
                    color: "white" // Ensuring text remains visible
                  }}
                >
                  {endDate || "N/A"}
                </td>
                <td>{sub.payment_method || "N/A"}</td>
                <td>
                  {sub.short_url ? (
                    <a href={sub.short_url} target="_blank" rel="noopener noreferrer">
                      View Details
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FetchSubscriptions;
